import { render, staticRenderFns } from "./ShopProductsDiscountsManagement.vue?vue&type=template&id=32247a66&scoped=true&"
import script from "./ShopProductsDiscountsManagement.vue?vue&type=script&lang=js&"
export * from "./ShopProductsDiscountsManagement.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductsDiscountsManagement.vue?vue&type=style&index=0&id=32247a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32247a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VRow,VSpacer})
